import { Model } from 'dva'
import { isAppWebsite } from 'Utils/helpers'
import { OrganisationsService } from '../../Service'
const initialState: any = {
  list: [],
  reportJson: [],
  columns: [],
  filters: {
    date: null,
    type: null,
    language: null,
  },
  loading: false,
}

const MIS: Model = {
  namespace: 'mis',
  state: initialState,
  effects: {
    *fetchMISReports({ payload, setLoading = () => {} }, { call, put, select }): any {
      setLoading(true)
      //backend request to fetch MIS reports;
      const data = yield call(OrganisationsService.organisationsFlowsMisReportsList, {
        organisationUuid: payload?.organisation_uuid,
        flowUuid: payload?.flow_uuid,
        limit: payload.limit || 10,
        callType: payload.call_type,
        language: payload.language,
        startDate: payload.start_date,
        endDate: payload.end_date,
        offset: payload.offset,
      })
      yield put({ type: 'setList', payload: data.results })
      setLoading(false)
      return data
    },

    *fetchMISReportsColumns({ payload, setLoading = () => {} }, { call, put, select }): any {
      setLoading(true)
      //backend request to fetch MIS reports;
      const data = yield call(
        OrganisationsService.organisationsFlowsMisReportsFetchColumnsRetrieve,
        {
          organisationUuid: payload?.organisation_uuid,
          flowUuid: payload?.flow_uuid,
        }
      )
      yield put({ type: 'setColumns', payload: data })
      setLoading(false)
      return data
    },

    *fetchReportJson({ payload, setLoading = () => {} }, { call, put, select }): any {
      setLoading(true)

      //backend request to fetch MIS reports;
      const data = yield call(OrganisationsService.organisationsFlowsMisReportsJsonRetrieve, {
        organisationUuid: payload?.organisation_uuid,
        flowUuid: payload?.flow_uuid,
      })
      yield put({ type: 'setReportJson', payload: data })
      setLoading(false)
      return data
    },
  },
  reducers: {
    setList: (state, action) => {
      return {
        ...state,
        list: action.payload,
      }
    },
    setColumns: (state, action) => {
      return {
        ...state,
        columns: action.payload,
      }
    },
    setReportJson: (state, action) => {
      return {
        ...state,
        reportJson: action.payload,
      }
    },
    setLoading: (state, action) => {
      console.info({ action })
      return {
        ...state,
        loading: action.payload,
      }
    },
    resetMIS: (state, action) => {
      return {
        ...state,
        ...initialState,
      }
    },
  },
}

export default MIS
